import React, { useState, useEffect, useRef } from "react";
import { groupByKey, applyDrag } from "../../../helpers/index";
import {
  localStorageSetItem,
  localStorageGetItem,
} from "../../../storage/index";
import { trans } from "../../../helpers/index";
import { Container, Draggable } from "react-smooth-dnd";
import ApiManager from "../../../apiManager/index";
import ReactNotification from "react-notifications-component";
import ErrorModal from "../../Fragments/ErrorModal";
import Modal from "../../Fragments/Modal";

function Services(props) {
  const [customerList, setCustomerList] = useState("");
  const [customerListLabels, setCustomerListLabels] = useState("");
  const [availableList, setAvailableList] = useState("");
  const [availableListLabels, setAvailableListLabels] = useState("");
  const [dnd1, setDnd1] = useState(localStorageGetItem("servicesDnd1") || [0]);
  const [dnd2, setDnd2] = useState(localStorageGetItem("servicesDnd2") || [1]);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showAlertServiceModal, setShowAlertServiceModal] = useState(false);
  const [showConfirmServiceModal, setShowConfirmServiceModal] = useState(false);
  const [confirmActivate, setConfirmActivate] = useState("");
  const [confirmData, setConfirmData] = useState(null);

  const isMountedRef = useRef(true);

  const notificationDOMRef = useRef(null);
  useEffect(() => {
    isMountedRef.current = true;
    initAsyncCalls();

    return () => {
      isMountedRef.current = false;
    };
  }, []);
  useEffect(() => {
    if (props.parentState.switchAccount) {
      setCustomerList("");
      setCustomerListLabels("");
      setAvailableList("");
      setAvailableListLabels("");
      initAsyncCalls(true);
    }
  }, [props.parentState.switchAccount]);

  function addNotification(inMessage, type = "success") {
    if (!isMountedRef.current) return;
    notificationDOMRef.current.addNotification({
      title: "",
      message: inMessage,
      type,
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 2000 },
      dismissable: { click: true },
    });
  }

  function initAsyncCalls(reset) {
    if (reset) {
      setCustomerList("");
      setCustomerListLabels("");
      setAvailableList("");
      setAvailableListLabels("");
    }

    ApiManager.getRequest(
      { jwt: props.getDecryptedToken() },
      "/service/list"
    ).then(customerServicesListSuccess, errorCallBack);

    ApiManager.getRequest(
      { jwt: props.getDecryptedToken() },
      "/service/availables"
    ).then(availableServicesListSuccess, errorCallBack);
  }

  function customerServicesListSuccess(resolve) {
    if (!isMountedRef.current) return;

    if (resolve.data.status === "OK") {
      const newLabels = {};
      resolve.data.data.services.forEach((item) => {
        newLabels[item.billing_id] = item.state === "enabled";
        newLabels[item.billing_id + "Disabled"] = false;
      });
      setCustomerList(resolve.data);
      setCustomerListLabels(newLabels);
    } else {
      setCustomerList(resolve.data);
    }
  }

  function availableServicesListSuccess(resolve) {
    if (!isMountedRef.current) return;

    if (resolve.data.status === "OK") {
      const newLabels = {};
      resolve.data.data.services.forEach((item) => {
        newLabels[item.billing_id] = item.state === "enabled";
        newLabels[item.billing_id + "Disabled"] = false;
      });
      setAvailableList(resolve.data);
      setAvailableListLabels(newLabels);
    } else {
      setAvailableList(resolve.data);
    }
  }

  function errorCallBack() {
    setShowErrorModal(true);
  }
  function getLabelStateByName(stateName) {
    if (stateName === "customerListLabels") {
      return [customerListLabels, setCustomerListLabels];
    } else if (stateName === "availableListLabels") {
      return [availableListLabels, setAvailableListLabels];
    }
    return [null, null];
  }
  function servicesListChangeHandler(item, stateName, own = false) {
    const [labels] = getLabelStateByName(stateName);
    if (!labels) return;

    const checkedValue = item.billing_id;
    const conflictsDescription = item.conflicts_description;
    if (item.disable_activation === "1") {
      if (own) {
        if (labels[checkedValue]) {
          setShowConfirmServiceModal(true);
          setConfirmActivate("");
          setConfirmData({ checkedValue, stateName, conflictsDescription });
        } else {
          setShowAlertServiceModal(true);
          setConfirmActivate("_activate");
        }
      } else {
        if (!labels[checkedValue]) {
          setShowConfirmServiceModal(true);
          setConfirmActivate("");
          setConfirmData({ checkedValue, stateName, conflictsDescription });
        } else {
          setShowAlertServiceModal(true);
          setConfirmActivate("_activate");
        }
      }
    } else if (item.disable_deactivation === "1") {
      if (!labels[checkedValue]) {
        setShowConfirmServiceModal(true);
        setConfirmActivate("_activate");
        setConfirmData({ checkedValue, stateName, conflictsDescription });
      } else {
        setShowAlertServiceModal(true);
        setConfirmActivate("");
      }
    } else {
      setConfirmData({ checkedValue, stateName, conflictsDescription });
      doToggleService({ checkedValue, stateName });
    }
  }

  function doToggleService(forceData) {
    const finalData = forceData || confirmData;
    if (!finalData) return;

    const { stateName, checkedValue } = finalData;
    const [labels, setLabels] = getLabelStateByName(stateName);
    if (!labels) return;
    const newLabels = { ...labels };
    newLabels[checkedValue] = !newLabels[checkedValue]; // toggle
    newLabels[checkedValue + "Disabled"] = true;

    setLabels(newLabels);
    setShowConfirmServiceModal(false);
    toggleService(stateName, checkedValue, !newLabels[checkedValue]);
  }
  function toggleService(stateName, checkedValue, isChecked) {

    const url = isChecked ? "/service/disable" : "/service/enable";
    ApiManager.postRequest(
      {
        _token: props.csrf_token.data,
        jwt: props.getDecryptedToken(),
        soc: checkedValue,
      },
      url
    ).then(
      (resolve) => {
        if (!isMountedRef.current) return;

        const [labels, setLabels] = getLabelStateByName(stateName);
        if (!labels) return;

        const updatedLabels = { ...labels };
        updatedLabels[checkedValue + "Disabled"] = false;

        if (resolve.data.status === "OK") {
          setLabels(updatedLabels);
          addNotification(resolve.data.message);
          initAsyncCalls(true);
        } else {
          addNotification(resolve.data.message, "danger");
          updatedLabels[checkedValue] = false;
          setLabels(updatedLabels);
        }
      },
      (error) => {
        errorCallBack(error);
      }
    );
  }
  function drawCustomerServicesList(isPaid, title) {
    if (!customerList || customerList === "" || customerList.status !== "OK") {
      return "";
    }

    const sortedServices = [...customerList.data.services].sort(
      (a, b) => a.service_sort_order_id - b.service_sort_order_id
    );
    const result = sortedServices.map((item, index) => {
      if (item.paid === isPaid) {
        return "";
      }

      let name = (
        <div className="list__inner-info list__inner-info--dark monserrat-medium">
          {item.name}
        </div>
      );
      if (item.url !== "") {
        name = (
          <a
            className="list__inner-info list__inner-info--dark db monserrat-medium"
            href={item.url.replace(/\?ref=mobile/, "")}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.name}
            <span className="list__next-btn sprite ver-top-box" />
          </a>
        );
      }

      return (
        <li className="list__item pr" key={index}>
          <div className="list__link pr">
            <div className="list__services-first">
              {name}
              <p className="list__inner-info">{item.price_note}</p>
            </div>
            {((item.disable_activation !== "1" &&
              item.disable_deactivation !== "1") ||
              (item.disable_activation === "0" &&
                item.disable_deactivation === "1") ||
              (item.disable_activation === "1" &&
                item.disable_deactivation === "0") ||
              (item.state === "enabled" && item.is_archived === "1")) && (
              <div className="list__services-second">
                <input
                  className="form__checkbox dn"
                  id={"customer-" + item.billing_id}
                  name={"customer-" + item.billing_id}
                  type="checkbox"
                  checked={
                    customerListLabels
                      ? customerListLabels[item.billing_id]
                      : false
                  }
                  onChange={() =>
                    servicesListChangeHandler(item, "customerListLabels", true)
                  }
                  disabled={
                    customerListLabels
                      ? customerListLabels[item.billing_id + "Disabled"]
                      : false
                  }
                />
                <label
                  className="form__check-label pa db"
                  htmlFor={"customer-" + item.billing_id}
                ></label>
              </div>
            )}
          </div>
        </li>
      );
    });
    if (result.join("") === "") {
      return "";
    }

    return (
      <>
        <li className="list__item list__item--title monserrat-medium">
          {title}
        </li>
        {result}
      </>
    );
  }

  function sectionFirst() {
    let content = (
      <div className="loading-box pr">
        <div className="loading" />
      </div>
    );

    if (customerList !== "" && customerList.status === "OK") {
      const paidGroup = drawCustomerServicesList(
        false,
        trans(props.trans, "services.customer.paid_title")
      );
      const freeGroup = drawCustomerServicesList(
        true,
        trans(props.trans, "services.customer.free_title")
      );
      let listItems = paidGroup || freeGroup;
      if (paidGroup === "" && freeGroup === "") {
        listItems = (
          <li className="list__item">
            <div className="list__link">
              {trans(props.trans, "empty.message")}
            </div>
          </li>
        );
      }

      content = (
        <div className="main-wrapper__list-out main-wrapper__list-out--services-big scroller-block">
          <ul className="list list--double list--big">
            {paidGroup}
            {freeGroup}
            {listItems !== paidGroup && listItems !== freeGroup ? listItems : ""}
          </ul>
        </div>
      );
    } else if (customerList !== "" && customerList.status === "ERROR") {
      content = <p className="error-message">{customerList.message}</p>;
    }

    return (
      <section className="main-wrapper__services">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--services monserrat-medium pr sprite-b move-cursor">
          {trans(props.trans, "services.customer.title")}
        </h2>
        {content}
      </section>
    );
  }

  function sectionSecond() {
    let content = (
      <div className="loading-box pr">
        <div className="loading" />
      </div>
    );

    if (availableList !== "" && availableList.status === "OK") {
      const services = [...availableList.data.services];
      const groupedData = groupByKey(services, "service_group_sort_order_id");

      let listItems = Object.values(groupedData).map((group) => {
        group.sort((a, b) => a.service_sort_order_id - b.service_sort_order_id);

        return group.map((inItem, inIndex) => {
          let title = null;
          if (inIndex === 0) {
            title = (
              <div
                className="list__item list__item--title monserrat-medium"
                key={"group-title-" + inItem.service_group_name}
              >
                {inItem.service_group_name}
              </div>
            );
          }

          let name = (
            <div className="list__inner-info list__inner-info--dark monserrat-medium">
              {inItem.name}
            </div>
          );
          if (inItem.url !== "") {
            name = (
              <a
                className="list__inner-info list__inner-info--dark db monserrat-medium"
                href={inItem.url.replace(/\?ref=mobile/, "")}
                target="_blank"
                rel="noopener noreferrer"
              >
                {inItem.name}
                <span className="list__next-btn sprite ver-top-box" />
              </a>
            );
          }

          return (
            <div className="list__item" key={inIndex}>
              {title}
              <div className="list__link pr">
                <div className="list__services-first">
                  {name}
                  <p className="list__inner-info">{inItem.price_note}</p>
                </div>

                {((inItem.disable_activation !== "1" &&
                  inItem.disable_deactivation !== "1") ||
                  (inItem.disable_activation === "0" &&
                    inItem.disable_deactivation === "1")) && (
                  <div className="list__services-second">
                    <input
                      className="form__checkbox dn"
                      id={"available-" + inItem.billing_id}
                      name={"available-" + inItem.billing_id}
                      type="checkbox"
                      checked={
                        availableListLabels
                          ? availableListLabels[inItem.billing_id]
                          : false
                      }
                      onChange={() =>
                        servicesListChangeHandler(inItem, "availableListLabels")
                      }
                      disabled={
                        availableListLabels
                          ? availableListLabels[inItem.billing_id + "Disabled"]
                          : false
                      }
                    />
                    <label
                      className="form__check-label pa db"
                      htmlFor={"available-" + inItem.billing_id}
                    />
                  </div>
                )}
              </div>
            </div>
          );
        });
      });
      if (!availableList.data.services.length) {
        listItems = (
          <li className="list__item">
            <div className="list__link">
              {trans(props.trans, "empty.message")}
            </div>
          </li>
        );
      }

      content = (
        <div className="main-wrapper__list-out main-wrapper__list-out--services-big scroller-block">
          <ul className="list list--double list--big">{listItems}</ul>
        </div>
      );
    } else if (availableList !== "" && availableList.status === "ERROR") {
      content = <p className="error-message">{availableList.message}</p>;
    }

    return (
      <section className="main-wrapper__services">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--services monserrat-medium pr sprite-b move-cursor">
          {trans(props.trans, "services.available.title")}
        </h2>
        {content}
      </section>
    );
  }
  function errorModal() {
    if (!showErrorModal) return null;
    return (
      <ErrorModal
        title={trans(props.trans, "error.modal.title")}
        description={trans(props.trans, "error.modal.description")}
        action_text={trans(props.trans, "error.modal.action_text")}
      />
    );
  }

  function alertToggleServiceModal() {
    if (!showAlertServiceModal) return null;
    return (
      <Modal
        title={trans(props.trans, "services.alert.toggle.title")}
        description={trans(
          props.trans,
          "services.alert.toggle.description" + confirmActivate
        )}
        agreeText={trans(props.trans, "services.alert.toggle.btn_title")}
        agreeAction={() => setShowAlertServiceModal(false)}
        className="modal--full"
      />
    );
  }

  function confirmToggleServiceModal() {
    if (!showConfirmServiceModal) return null;

    let conflictsDescription = "";
    if (confirmData?.conflictsDescription) {
      conflictsDescription = confirmData.conflictsDescription + "<br />";
    }

    return (
      <Modal
        title={trans(props.trans, "services.confirm.toggle.title")}
        htmlDescription={
          conflictsDescription +
          trans(
            props.trans,
            "services.confirm.toggle.description" + confirmActivate
          )
        }
        agreeText={trans(props.trans, "services.confirm.toggle.btn_title")}
        agreeAction={() => doToggleService()}
        showCancelButton={true}
        cancelText={trans(
          props.trans,
          "services.confirm.toggle.cancel_btn_title"
        )}
        cancelAction={() => setShowConfirmServiceModal(false)}
        className="modal--full"
      />
    );
  }
  function notificationRender() {
    return <ReactNotification ref={notificationDOMRef} />;
  }
  const dndList = [
    <div className="row-drag-handle" key="dnd-1">
      {sectionFirst()}
    </div>,
    <div className="row-drag-handle" key="dnd-2">
      {sectionSecond()}
    </div>,
  ];
  localStorageSetItem("servicesDnd1", dnd1);
  localStorageSetItem("servicesDnd2", dnd2);

  return (
    <div className="main-wrapper__double-list main-wrapper__double-list--full-width">
      {notificationRender()}

      <div className="main-wrapper__double-list-item ver-top-box">
        <Container
          orientation="vertical"
          dragHandleSelector=".main-wrapper__sub-title"
          dropPlaceholder={{
            className: "box-drop-preview",
          }}
          groupName="1"
          getChildPayload={(i) => dnd1[i]}
          onDrop={(e) => setDnd1(applyDrag(dnd1, e))}
        >
          {dnd1.map((index) => (
            <Draggable key={index}>{dndList[index]}</Draggable>
          ))}
        </Container>
      </div>

      <div className="main-wrapper__double-list-item ver-top-box">
        <Container
          orientation="vertical"
          dragHandleSelector=".main-wrapper__sub-title"
          dropPlaceholder={{
            className: "box-drop-preview",
          }}
          groupName="1"
          getChildPayload={(i) => dnd2[i]}
          onDrop={(e) => setDnd2(applyDrag(dnd2, e))}
        >
          {dnd2.map((index) => (
            <Draggable key={index}>{dndList[index]}</Draggable>
          ))}
        </Container>
      </div>

      {errorModal()}
      {alertToggleServiceModal()}
      {confirmToggleServiceModal()}
    </div>
  );
}

export default Services;
